import { render, staticRenderFns } from "./PostStatusTransition.vue?vue&type=template&id=510db0b8&scoped=true"
import script from "./PostStatusTransition.vue?vue&type=script&lang=js"
export * from "./PostStatusTransition.vue?vue&type=script&lang=js"
import style0 from "./PostStatusTransition.vue?vue&type=style&index=0&id=510db0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510db0b8",
  null
  
)

export default component.exports